module.exports = __webpack_public_path__ + "static/media/Luna Lovegood 3.55ca4de1.jpg";